export default {
  type: "object",
  properties: {
    id: {
      type: "integer",
      description: "unique identifier (1 = female, 2 = male, 3 = unisex)",
      example: "1"
    },
    label: {
      type: "string",
      description: "description",
      example: "male"
    }
  }
};
